/**
 * 遷移元に応じたサイトID
 * @param ANA_TOUR ANAツアーサイトからの遷移
 * @param ANA_APP ANAアプリからの遷移
 * @param ASW_INT 国際ASWからの線に
 * @param ASW_APP 他のアプリからの遷移
 * @param ASW_TOP TOPからの遷移
 * @param RESERVATION 予約詳細からの遷移
 */
export const SITE_ID = {
  ANA_TOUR: 'ANA_TOUR',
  ANA_APP: 'ANA_APP',
  ASW_INT: 'ASW_INT',
  ASW_APP: 'ASW_APP',
  ASW_TOP: 'ORC_TOP',
  RESERVATION: 'RESERVATION',
  FLIGHT_AVAILABILITY: 'FLIGHT_AVAILABILITY',
} as const;
